import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import Image from '../Image';
import RemoveConfirm from './RemoveConfirm';
import { uploadClass } from './styles';
var DefaultProps = {
  renderResult: function renderResult(a) {
    return a;
  }
};

var ImageResult =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageResult, _PureComponent);

  var _super = _createSuper2(ImageResult);

  function ImageResult(props) {
    var _this;

    _classCallCheck(this, ImageResult);

    _this = _super.call(this, props);
    _this.image = void 0;
    _this.state = {
      confirm: false
    };
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    _this.handleRecover = _this.handleRecover.bind(_assertThisInitialized(_this));
    _this.bindImage = _this.bindImage.bind(_assertThisInitialized(_this));
    _this.handlePreview = _this.handlePreview.bind(_assertThisInitialized(_this));
    _this.handleConfirmChange = _this.handleConfirmChange.bind(_assertThisInitialized(_this));
    _this.preview = _this.preview.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageResult, [{
    key: "bindImage",
    value: function bindImage(image) {
      this.image = image;
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      if (this.props.onRemove) this.props.onRemove(this.props.index);
    }
  }, {
    key: "handleRecover",
    value: function handleRecover() {
      var _this$props = this.props,
          onRecover = _this$props.onRecover,
          value = _this$props.value,
          index = _this$props.index;

      if (onRecover) {
        onRecover(index, value);
      }
    }
  }, {
    key: "handleConfirmChange",
    value: function handleConfirmChange(confirm) {
      this.setState({
        confirm: confirm
      });
    }
  }, {
    key: "preview",
    value: function preview() {
      if (!this.image) return;
      this.image.preview();
    }
  }, {
    key: "handlePreview",
    value: function handlePreview() {
      var _this2 = this;

      var _this$props2 = this.props,
          onPreview = _this$props2.onPreview,
          _this$props2$renderRe = _this$props2.renderResult,
          renderResult = _this$props2$renderRe === void 0 ? DefaultProps.renderResult : _this$props2$renderRe,
          value = _this$props2.value,
          index = _this$props2.index,
          values = _this$props2.values;

      if (onPreview) {
        var url = renderResult(value);
        onPreview(url, value, index, values, {
          preview: function preview() {
            return _this2.preview();
          }
        });
        return;
      }

      this.preview();
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var removeConfirm = this.props.removeConfirm;
      var confirm = this.state.confirm;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('image-options', confirm && 'image-active')
        },
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('options-item'),
          onClick: this.handlePreview
        }, icons.Preview), this.props.onRemove &&
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('options-item', 'options-remove'),
          onClick: removeConfirm ? undefined : this.handleRemove
        }, icons.Delete,
        /*#__PURE__*/
        React.createElement(RemoveConfirm, {
          onVisibleChange: this.handleConfirmChange,
          onRemove: this.handleRemove,
          confirm: removeConfirm
        })))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          _this$props3$renderRe = _this$props3.renderResult,
          renderResult = _this$props3$renderRe === void 0 ? DefaultProps.renderResult : _this$props3$renderRe,
          recoverAble = _this$props3.recoverAble,
          renderContent = _this$props3.renderContent,
          style = _this$props3.style,
          showRecover = _this$props3.showRecover,
          index = _this$props3.index,
          values = _this$props3.values;
      var className = uploadClass('image-item', 'image-result', recoverAble && 'to-be-delete');
      var url = renderResult(value);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: className
        }, url && (renderContent ? renderContent(url, value, index, values) :
        /*#__PURE__*/
        React.createElement(Image, {
          ref: this.bindImage,
          src: url,
          href: url,
          fit: "center",
          width: "auto",
          height: 0,
          className: uploadClass('image-bg')
        })), showRecover &&
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('recover'),
          onClick: this.handleRecover
        }, icons.Recovery), this.showRemove &&
        /*#__PURE__*/
        React.createElement("span", {
          className: uploadClass('delete'),
          onClick: this.handleRemove
        }), !renderContent && this.renderOptions())
      );
    }
  }, {
    key: "showRemove",
    get: function get() {
      var _this$props4 = this.props,
          onRemove = _this$props4.onRemove,
          renderContent = _this$props4.renderContent;
      return onRemove && renderContent;
    }
  }]);

  return ImageResult;
}(PureComponent);

ImageResult.defaultProps = DefaultProps;
export default ImageResult;